import { toast } from 'react-toastify';

export function mostrarToast(tipo, mensagem) {
  let config = {
    position: 'top-right',
    autoClose: 3000,
    containerId: 'fluxo-caixa',
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    className: '',
  };

  switch (tipo) {
    case 'sucesso':
      config.className = 'bg-green-600 text-white font-semibold shadow-md';
      toast.success(mensagem, config);
      break;
    case 'erro':
      config.className = 'bg-red-600 text-white font-semibold shadow-md';
      toast.error(mensagem, config);
      break;
    case 'alerta':
      config.className = 'bg-yellow-500 text-white font-semibold shadow-md';
      toast.warning(mensagem, config);
      break;
    case 'info':
    default:
      config.className = 'bg-blue-500 text-white font-semibold shadow-md';
      toast.info(mensagem, config);
      break;
  }
}
